export function formatDate(inputDate) {
  const [year, month, day] = inputDate.split('-');
  const shortYear = year.slice(-2);
  const formattedDate = `${day}.${month}.${shortYear}`;

  return formattedDate;
}
